import React, { useState, useEffect, useRef } from 'react'
import Header from '../Utilities/Header'
import Footer from '../Utilities/Footer'
import emailjs from '@emailjs/browser';
import fb from "../Firebase/firebase";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UpArrow from '../Utilities/UpArrow';
import { Link } from 'react-router-dom';
const DB = fb.firestore()
const CF = DB.collection('Axcelto_Form');

const Home = () => {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const href = window.location.href.substring(
      window.location.href.lastIndexOf('#') + 1
    );
    const element = document.getElementById(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }

  }, []);

  const form = useRef();
  const [userData, setUserData] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    Quantity: "",
    RetailerSelfUse: ""
  });

  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUserData({ ...userData, [name]: value });
  }

  //connect with firebase
  const SubmitData = async (e) => {
    e.preventDefault();
    const { Name, Email, Mobile, Quantity, RetailerSelfUse, Products } = userData;
    if (Name && Email && Mobile && Quantity && RetailerSelfUse && Products) {


      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(userData.Email)) {
        toast.warning('Please enter a valid email address');
        return
      }

      if (typeof Mobile !== "undefined") {

        var pattern = new RegExp(/^[0-9\b]+$/);

        if (!pattern.test(userData.Mobile)) {
          toast.warning("Please enter only number.");
          return

        } else if (userData.Mobile.length !== 10) {
          toast.warning("Please enter 10 digit Mobile number.");
          return
        }
      }

      try {

        CF.add({
          Name: Name,
          Email: Email,
          Mobile: Mobile,
          Quantity: Quantity,
          RetailerSelfUse: RetailerSelfUse,
          Products: Products
        }).then((docRef) => {
          toast.success('Order Received Successfully');
        }).catch((error) => {
          console.error("error:", error);
        });

        emailjs.sendForm('service_91sqknx', 'template_4j6wwya', form.current, '6pbmyufjSURA60XeS')
          .then((result) => {
            console.log(result.text);

          }, (error) => {
            console.log(error.text);
          });

        setUserData({
          Name: "",
          Email: "",
          Mobile: "",
          Quantity: "",
          RetailerSelfUse: "",
          Products: ""
        })

        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
        toast.warning("Error adding document")
      }
    }
    else {
      toast.warning('Please fill the data');
    }
  };

  return (
    <div>
      <Header />
      <ToastContainer />
      <UpArrow />

      {/* Banner */}
      <div className='banner'>
        <div className="banner-shape"></div>
        <div className="banner-shape2"></div>
        <div className="banner-text">
          <span>Welcome To</span>
          <h1>Axcelto</h1>
          <p>Rivaroxaban is used to treat and manage venous thromboembolism as a postoperative thromboprophylaxis for patients undergoing orthopedic surgery to prevent stroke in patients with non-valvular atrial fibrillation and recently has received approval as an add-on drug for secondary prevention of acute coronary syndrome and peripheral arterial disease. It is a novel oral anticoagulant (NOAC) and is commonly referred to as a blood thinner agent.</p>
          <a href="#our-products">Our Products</a>
        </div>
        <div className="banner-img">
          <div className="banner-img-content img1" >
            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704872760/Axcelto/Banner/1_wdttkl.webp" alt="product1" />
          </div>
          <div className="banner-img-content img2">
            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704872761/Axcelto/Banner/2_i7d7ow.webp" alt="product2" />
          </div>
          {/* <div className="banner-img-content img3">
            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704116422/Welltoo-Pro/Banner/2_r2ghfc.webp" alt="product3" />
          </div> */}
          {/* <div className="banner-img-content img4">
                    <img  src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1701437684/callaxo%20max.in/Callaxo-Max_bg_remove_xm6jm2.png" alt="product3" />
                </div> */}
        </div>
      </div>
      {/* Banner ends */}

      {/* Products */}
      <div className="products" id='our-products' >
        <div className="section-title">
          <h2>Our Products</h2>
        </div>
        <div className='products-body'>
          <div className="products-card">
            <div className="products-img">
              <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704872580/Axcelto/Axcelto%2020/Product/1_bkgffg.webp" alt="product" />
            </div>
            <div className="products-text">
              <h3>Axcelto 20mg</h3>
              <p>Axcelto 20mg Tablet is a medicine known as an anticoagulant or blood thinner. It helps prevent and treat blood clots. It is used to reduce the risk of stroke and heart attack. It prevents and treats clot formation in the veins of your legs, lungs, brain and heart.</p>
              <div className="product-text-btn btn2">
                <Link to={"/products/axcelto-20"}>
                  <svg clipRule="evenodd" fillRule="evenodd" height="512" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 267 267" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m109.753 101.838c.001-.954.206-1.897.603-2.765.003-.006.005-.011.007-.016 2.831-6.283 4.395-13.254 4.395-20.588 0-27.931-22.677-50.608-50.608-50.608-27.932 0-50.608 22.677-50.608 50.608s22.676 50.608 50.608 50.608c7.33 0 14.297-1.562 20.587-4.37.008-.003.017-.007.025-.011.865-.395 1.805-.6 2.756-.6h.03c2.452-.024 6.632-.024 10.452-.024 6.491 0 11.753-5.262 11.753-11.753zm-57.652-35.418h-11.152c-1.726 0-3.125 1.4-3.125 3.125v17.847c0 1.726 1.399 3.125 3.125 3.125h11.152v11.153c0 1.726 1.399 3.125 3.125 3.125h17.847c1.726 0 3.125-1.399 3.125-3.125v-11.153h11.153c1.726 0 3.125-1.399 3.125-3.125v-17.847c0-1.725-1.399-3.125-3.125-3.125h-11.153v-11.152c0-1.726-1.399-3.125-3.125-3.125h-17.847c-1.726 0-3.125 1.399-3.125 3.125z" /><path d="m75.311 132.103c-3.603.747-7.337 1.141-11.161 1.141-4.087 0-8.071-.449-11.9-1.299v92.324c0 8.023 6.514 14.537 14.537 14.537h171.799c8.023 0 14.537-6.514 14.537-14.537v-134.431c0-8.023-6.514-14.536-14.537-14.536h-8.524v120.737c0 9.897-7.729 18.072-17.61 18.627-15.844.89-44.767 2.514-55.345 3.108-2.945.166-5.897.166-8.841 0-10.579-.594-39.501-2.218-55.345-3.108-9.882-.555-17.61-8.73-17.61-18.627z" /><path d="m155.811 55.637v158.029c.355-.014.709-.032 1.063-.052 10.578-.594 39.5-2.218 55.344-3.108 7.675-.431 13.678-6.78 13.678-14.467 0-27.796 0-101.977 0-131.81 0-4.119-1.754-8.044-4.822-10.793-3.068-2.748-7.161-4.061-11.256-3.61-14.423 1.59-37.593 4.144-49.636 5.471-1.454.16-2.911.274-4.371.34zm-43.912-4.009c4.16 7.38 6.658 15.816 6.988 24.802l9.514 1.178c5.361.663 9.387 5.218 9.387 10.62v31.294c0 3.067-1.316 5.987-3.615 8.018-2.298 2.032-5.357 2.979-8.401 2.603l-20.39-2.524c-.622-.077-1.226-.206-1.808-.383-1.735.649-3.613 1.003-5.574 1.003-3.806 0-7.968 0-10.411.024-.024 0-.048 0-.071 0-.354 0-.703.076-1.025.223-.019.009-.038.017-.058.026-2.243 1.001-4.566 1.857-6.958 2.553v64.974c0 7.687 6.003 14.036 13.678 14.467 15.844.89 44.766 2.514 55.344 3.108.354.02.708.038 1.062.052v-158.029c-1.459-.066-2.917-.18-4.37-.34l-33.292-3.669zm96.098 128.655c-11.541 1.272-30.08 3.315-39.715 4.377-1.714.189-2.953 1.735-2.764 3.449s1.734 2.953 3.449 2.764c9.635-1.062 28.174-3.106 39.714-4.378 1.715-.188 2.953-1.734 2.764-3.448s-1.734-2.953-3.448-2.764zm-111.306 6.212c11.541 1.272 30.08 3.316 39.715 4.378 1.714.189 3.26-1.05 3.449-2.764s-1.05-3.26-2.764-3.449c-9.636-1.062-28.175-3.105-39.715-4.377-1.714-.189-3.26 1.05-3.449 2.764-.188 1.714 1.05 3.26 2.764 3.448zm111.306-31.568c-11.541 1.272-30.08 3.316-39.715 4.378-1.714.189-2.953 1.734-2.764 3.448s1.734 2.953 3.449 2.764c9.635-1.062 28.174-3.105 39.714-4.377 1.715-.189 2.953-1.735 2.764-3.449s-1.734-2.953-3.448-2.764zm-111.306 6.213c11.541 1.272 30.08 3.315 39.715 4.377 1.714.189 3.26-1.05 3.449-2.764s-1.05-3.259-2.764-3.448c-9.636-1.062-28.175-3.106-39.715-4.378-1.714-.189-3.26 1.05-3.449 2.764-.188 1.714 1.05 3.26 2.764 3.449zm112.687-75.435c0-3.068-1.316-5.987-3.614-8.019-2.298-2.031-5.358-2.979-8.402-2.602l-20.39 2.524c-5.361.663-9.387 5.218-9.387 10.62v31.294c0 3.067 1.316 5.987 3.614 8.018 2.299 2.032 5.358 2.979 8.402 2.603l20.39-2.524c5.361-.664 9.387-5.219 9.387-10.621 0-8.247 0-22.268 0-31.293z" /></svg>
                  <span>Learn More</span>
                </Link>
                <a href="#buy">
                  <svg id="Capa_1" enableBackground="new 0 0 50.613 50.613" height="512" viewBox="0 0 50.613 50.613" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><g><path d="m49.569 11.145h-29.514c-.961 0-1.508.743-1.223 1.661l4.669 13.677c.23.738 1.044 1.336 1.817 1.336h19.35c.773 0 1.586-.598 1.814-1.336l4.069-14c.232-.739-.207-1.338-.982-1.338z" /><circle cx="22.724" cy="43.575" r="4.415" /><circle cx="41.406" cy="43.63" r="4.415" /><path d="m46.707 32.312h-25.821l-10.337-29.744h-8.049c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5h4.493l10.337 29.744h29.377c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5z" /></g></g></g></svg>
                  <span>Buy Now</span>
                </a>
              </div>

            </div>
          </div>

          <div className="products-card">
            <div className="products-img">
              <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704872554/Axcelto/Axcelto%202.5/Product/1_kxvfmb.webp" alt="product" />
            </div>
            <div className="products-text">
              <h3>Axcelto 2.5mg</h3>
              <p>Axcelto 2.5mg Tablet is a medicine known as an anticoagulant or blood thinner. It helps prevent and treat blood clots. It is used to reduce the risk of stroke and heart attack. It prevents and treats clot formation in the veins of your legs, lungs, brain, and heart.</p>
              <div className="product-text-btn btn2">
                <Link to={"/products/axcelto-2.5"}>
                  <svg clipRule="evenodd" fillRule="evenodd" height="512" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 267 267" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m109.753 101.838c.001-.954.206-1.897.603-2.765.003-.006.005-.011.007-.016 2.831-6.283 4.395-13.254 4.395-20.588 0-27.931-22.677-50.608-50.608-50.608-27.932 0-50.608 22.677-50.608 50.608s22.676 50.608 50.608 50.608c7.33 0 14.297-1.562 20.587-4.37.008-.003.017-.007.025-.011.865-.395 1.805-.6 2.756-.6h.03c2.452-.024 6.632-.024 10.452-.024 6.491 0 11.753-5.262 11.753-11.753zm-57.652-35.418h-11.152c-1.726 0-3.125 1.4-3.125 3.125v17.847c0 1.726 1.399 3.125 3.125 3.125h11.152v11.153c0 1.726 1.399 3.125 3.125 3.125h17.847c1.726 0 3.125-1.399 3.125-3.125v-11.153h11.153c1.726 0 3.125-1.399 3.125-3.125v-17.847c0-1.725-1.399-3.125-3.125-3.125h-11.153v-11.152c0-1.726-1.399-3.125-3.125-3.125h-17.847c-1.726 0-3.125 1.399-3.125 3.125z" /><path d="m75.311 132.103c-3.603.747-7.337 1.141-11.161 1.141-4.087 0-8.071-.449-11.9-1.299v92.324c0 8.023 6.514 14.537 14.537 14.537h171.799c8.023 0 14.537-6.514 14.537-14.537v-134.431c0-8.023-6.514-14.536-14.537-14.536h-8.524v120.737c0 9.897-7.729 18.072-17.61 18.627-15.844.89-44.767 2.514-55.345 3.108-2.945.166-5.897.166-8.841 0-10.579-.594-39.501-2.218-55.345-3.108-9.882-.555-17.61-8.73-17.61-18.627z" /><path d="m155.811 55.637v158.029c.355-.014.709-.032 1.063-.052 10.578-.594 39.5-2.218 55.344-3.108 7.675-.431 13.678-6.78 13.678-14.467 0-27.796 0-101.977 0-131.81 0-4.119-1.754-8.044-4.822-10.793-3.068-2.748-7.161-4.061-11.256-3.61-14.423 1.59-37.593 4.144-49.636 5.471-1.454.16-2.911.274-4.371.34zm-43.912-4.009c4.16 7.38 6.658 15.816 6.988 24.802l9.514 1.178c5.361.663 9.387 5.218 9.387 10.62v31.294c0 3.067-1.316 5.987-3.615 8.018-2.298 2.032-5.357 2.979-8.401 2.603l-20.39-2.524c-.622-.077-1.226-.206-1.808-.383-1.735.649-3.613 1.003-5.574 1.003-3.806 0-7.968 0-10.411.024-.024 0-.048 0-.071 0-.354 0-.703.076-1.025.223-.019.009-.038.017-.058.026-2.243 1.001-4.566 1.857-6.958 2.553v64.974c0 7.687 6.003 14.036 13.678 14.467 15.844.89 44.766 2.514 55.344 3.108.354.02.708.038 1.062.052v-158.029c-1.459-.066-2.917-.18-4.37-.34l-33.292-3.669zm96.098 128.655c-11.541 1.272-30.08 3.315-39.715 4.377-1.714.189-2.953 1.735-2.764 3.449s1.734 2.953 3.449 2.764c9.635-1.062 28.174-3.106 39.714-4.378 1.715-.188 2.953-1.734 2.764-3.448s-1.734-2.953-3.448-2.764zm-111.306 6.212c11.541 1.272 30.08 3.316 39.715 4.378 1.714.189 3.26-1.05 3.449-2.764s-1.05-3.26-2.764-3.449c-9.636-1.062-28.175-3.105-39.715-4.377-1.714-.189-3.26 1.05-3.449 2.764-.188 1.714 1.05 3.26 2.764 3.448zm111.306-31.568c-11.541 1.272-30.08 3.316-39.715 4.378-1.714.189-2.953 1.734-2.764 3.448s1.734 2.953 3.449 2.764c9.635-1.062 28.174-3.105 39.714-4.377 1.715-.189 2.953-1.735 2.764-3.449s-1.734-2.953-3.448-2.764zm-111.306 6.213c11.541 1.272 30.08 3.315 39.715 4.377 1.714.189 3.26-1.05 3.449-2.764s-1.05-3.259-2.764-3.448c-9.636-1.062-28.175-3.106-39.715-4.378-1.714-.189-3.26 1.05-3.449 2.764-.188 1.714 1.05 3.26 2.764 3.449zm112.687-75.435c0-3.068-1.316-5.987-3.614-8.019-2.298-2.031-5.358-2.979-8.402-2.602l-20.39 2.524c-5.361.663-9.387 5.218-9.387 10.62v31.294c0 3.067 1.316 5.987 3.614 8.018 2.299 2.032 5.358 2.979 8.402 2.603l20.39-2.524c5.361-.664 9.387-5.219 9.387-10.621 0-8.247 0-22.268 0-31.293z" /></svg>
                  <span>Learn More</span>
                </Link>
                <a href="#buy">
                  <svg id="Capa_1" enableBackground="new 0 0 50.613 50.613" height="512" viewBox="0 0 50.613 50.613" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><g><path d="m49.569 11.145h-29.514c-.961 0-1.508.743-1.223 1.661l4.669 13.677c.23.738 1.044 1.336 1.817 1.336h19.35c.773 0 1.586-.598 1.814-1.336l4.069-14c.232-.739-.207-1.338-.982-1.338z" /><circle cx="22.724" cy="43.575" r="4.415" /><circle cx="41.406" cy="43.63" r="4.415" /><path d="m46.707 32.312h-25.821l-10.337-29.744h-8.049c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5h4.493l10.337 29.744h29.377c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5z" /></g></g></g></svg>
                  <span>Buy Now</span>
                </a>
              </div>

            </div>
          </div>


        </div>
      </div >
      {/* Products ends */}

      {/* Order */}
      <div className="order" id='buy'>
        <div className="section-title">
          <h2>Buy Now</h2>
        </div>

        <div className="order-body">
          <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702878141/Callaxo/drug-capsule-pill-from-drug-prescription-drugstore-pharmacy-treatment-health-medicine_x21c4i.jpg" alt="" />
          <form action="POST" ref={form}>
            <div className='input'>
              <input type="text" placeholder='Name'
                name='Name'
                value={userData.Name}
                onChange={postUserData}
                required />
              <input type="email" placeholder='Email'
                style={{ textTransform: 'lowercase' }}
                name='Email'
                value={userData.Email}
                onChange={postUserData}
                required />
            </div>
            <div className='input'>
              <input type="text" placeholder='Mobile'
                name='Mobile'
                value={userData.Mobile}
                onChange={postUserData}
                required />
              <input type="number" min={1} placeholder='Quantity'
                name='Quantity'
                value={userData.Quantity}
                onChange={postUserData}
                required />
            </div>
            <input style={{ display: "none" }}
              type="text"
              name="productName"
              value="Axcelto"
            />
            <select name='RetailerSelfUse'
              value={userData.RetailerSelfUse}
              onChange={postUserData}>
              <option hidden selected="selected" disabled="disabled">Retailer / Self Use</option>
              <option value="Retailer">Retailer</option>
              <option value="Self Use">Self Use</option>
            </select>
            <select name="Products"
              value={userData.Products}
              onChange={postUserData}>
              <option hidden selected="selected" disabled="disabled">Select Product</option>
              <option value="Axcelto 20">Axcelto 20</option>
              <option value="Axcelto 2.5">Axcelto 2.5</option>
            </select>
            <button onClick={SubmitData}>Submit</button>
          </form>

        </div>
      </div>
      {/* Order Ends */}

      <Footer />
    </div >
  )
}

export default Home
